import { PreferenceCodeService } from './../../features/preference-code/services/preference-code.service';
import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from '../../core/layout/layout.component';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ManualJournalService } from '../../features/manual-journals/services/manual-journal.service';
import { ToastrService } from 'ngx-toastr';
import { CurrencyAdjustmentService } from '../../features/currency-adjustment/services/currency-adjustment.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UploadFileService } from '../../shared/services/file-upload.service';
import { ConfirmDialog } from '../../shared/components/confirm-dialog/confirm-dialog';
import { nonNegativeValidator } from '../../shared/services/validations';
import { ChartOfAccountsService } from '../../features/chart-of-accounts/services/chart-of-accounts.service';
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
// import { PreferenceService } from '../../shared/services/preference.service';

@Component({
  selector: 'app-manual-journal-new',
  standalone: true,
  imports: [
    CommonModule,
    LayoutComponent,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule
],
  templateUrl: './manual-journal-new.component.html',
  styleUrl: './manual-journal-new.component.scss',
})
export class ManualJournalNewComponent implements OnInit {
  accountType: any;
  parentAccountId: any;
  isSubAccount: any;
  newJournalForm!: FormGroup;
  successMessage: string | null = null;
  errorMessage: string | null = null;
  loading: boolean = false;
  journalData: any;
  search: string = '';
  filter: any = {};
  journalId: number;
  journalEntry: any[] = [];
  journalEntryId: number | null = null;
  public currencyData: any[] = [];
  public accountData: any[] = [];
  public partnersData: any[] = []; prefix: any;
  journalNumber: any;
  private searchSubject = new Subject<string>();

  // file: any = null;
  // csvFile: File[] = [];
  url: string = '';
  narration: any;
  // fileDetailsArray: {
  //   fileName: string;
  //   fileUrl: string;
  //   id?: number;
  //   // isNew: boolean;
  // }[] = [];

  // @ViewChild('fileInput') fileInput!: ElementRef;
  currentFiles: File[] = [];

  readonly dialog = inject(MatDialog);

  private status: 'Draft' | 'Posted' = 'Draft';

  constructor(
    private journalService: ManualJournalService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private currencyService: CurrencyAdjustmentService,
    private accountService: ChartOfAccountsService,
    private router: Router,
    private route: ActivatedRoute,
    private documentUploadService: UploadFileService,
    private preferenceService: PreferenceCodeService
  ) {
    this.narration = '';
  }

  ngOnInit(): void {
    this.fetchAccounts();
    // this.fetchPartners();
    this.initForm();
    
    this.route.paramMap.subscribe((params) => {
      const id = params.get('id');
      if (id) {
        this.journalId = +id;
        this.loadJournalData();
      }
    });
    if (!this.journalId) {
      this.addJournalEntry();
      this.addJournalEntry();
      this.preferenceCode();
    }
    this.searchSubject
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.fetchAccounts(searchTerm);
      });
  }

  initForm(): void {
    this.newJournalForm = this.fb.group({
      journalId: [null],
      date: ['', Validators.required],
      journalNo: ['', Validators.required],
      reference: ['', Validators.required], 
      notes: ['', [Validators.required, Validators.maxLength(500)]],
      journalEntries: this.fb.array([]),
      // journalAttachments: this.fb.array([]),
    });
  }

  preferenceCode(search: string = '') {
    this.preferenceService.fetchPreferenceCodes(search, 'Manual Journal').subscribe({
      next: (response) => {
        response.forEach((prefix: any) => {
          this.journalNumber = prefix?.sequenceCode;
        });
        this.newJournalForm.patchValue({ journalNo: this.journalNumber });
      },
      error: (error) => {
        console.error(error, 'Error');
      },
    });
  }

  private loadJournalData(): void {
    if (this.journalId !== null) {
      this.journalService.getJournalById(this.journalId).subscribe({
        next: (data) => {
          this.journalData = data;
          this.journalEntry=this.journalData.journalEntries||[]    
          console.log("journalEntry",this.journalEntry);
                
          this.populateForm();
        },
        error: (error) => console.error(error),
      });
    } else {
      console.warn('Journal ID is null; cannot load journal data.');
    }
  }

  private populateForm(): void {
    this.newJournalForm.patchValue({
      journalId: this.journalData.id,
      date: new Date(Number(this.journalData.date)),
      journalNo: this.journalData.journalNo,
      reference: this.journalData.reference,
      notes: this.journalData.notes,
    });

    // Initialize journal entries if available
    if (this.journalData.journalEntries) {
      this.journalData.journalEntries.forEach((entry: any) => {
        this.journalEntries.push(this.createJournalEntryGroup(entry));
      });
    }

    // Initialize journal attachments if available
    // if (this.journalData.journalAttachments) {
    //   this.journalData.journalAttachments.forEach((attachment: any) => {
    //     const attachmentData = this.fb.group({
    //       id: attachment.id,
    //       fileName: attachment.fileName,
    //       fileUrl: attachment.fileUrl,
    //     });
    //     this.journalAttachments.push(attachmentData);
    //     this.fileDetailsArray.push({
    //       id: attachment.id,
    //       fileName: attachment.fileName,
    //       fileUrl: attachment.fileUrl,
    //       //   isNew: true,
    //     });
    //   });
    // }
  }

  onBlur(event: FocusEvent) {
    const inputElement = event.target as HTMLInputElement;
    this.narration = inputElement.value;
    this.journalEntries.controls.forEach((control) => {
      if (control instanceof FormGroup) {
        control.patchValue({
          description: this.narration // Set the desired value for the 'note' field
        });
      }
    });
  }

  get journalEntries(): FormArray {
    return this.newJournalForm.get('journalEntries') as FormArray;
  }

  // get journalAttachments(): FormArray {
  //   return this.newJournalForm.get('journalAttachments') as FormArray;
  // }

  get totalDebit(): number {
    return this.journalEntries.controls.reduce((sum, entry) => {
      return sum + (entry.get('debit')?.value || 0);
    }, 0);
  }

  get totalCredit(): number {
    return this.journalEntries.controls.reduce((sum, entry) => {
      return sum + (entry.get('credit')?.value || 0);
    }, 0);
  }

  get difference(): number {
    return this.totalDebit - this.totalCredit;
  }

  addJournalEntry(): void {
    this.journalEntries.push(this.createJournalEntryGroup());
  }

  private createJournalEntryGroup(entry: any = {}): FormGroup {
    const journalEntry = this.fb.group({
      id: [entry.id || null],
      accountId: [entry.accountId || '', Validators.required],
      description: [entry.description || this.narration || ''],
      debit: [
        { value: entry.debit || 0, disabled: false },
        [Validators.required, nonNegativeValidator],
      ],
      credit: [
        { value: entry.credit || 0, disabled: false },
        [Validators.required, nonNegativeValidator],
      ],
    });
  
    // Attach listeners
    journalEntry.get('debit')?.valueChanges.subscribe((debitValue) => {
      const creditControl = journalEntry.get('credit');
      if ((debitValue ?? 0) > 0) {
        if (creditControl?.enabled) {
          creditControl.setValue(0, { emitEvent: false });
          creditControl.disable({ emitEvent: false });
        }
      } else {
        if (creditControl?.disabled) {
          creditControl.enable({ emitEvent: false });
        }
      }
    });
  
    journalEntry.get('credit')?.valueChanges.subscribe((creditValue) => {
      const debitControl = journalEntry.get('debit');
      if ((creditValue ?? 0) > 0) {
        if (debitControl?.enabled) {
          debitControl.setValue(0, { emitEvent: false });
          debitControl.disable({ emitEvent: false });
        }
      } else {
        if (debitControl?.disabled) {
          debitControl.enable({ emitEvent: false });
        }
      }
    });
  
    // Set initial state AFTER attaching subscriptions
    if ((entry.debit ?? 0) > 0) {
      journalEntry.get('credit')?.disable({ emitEvent: false });
    } else if ((entry.credit ?? 0) > 0) {
      journalEntry.get('debit')?.disable({ emitEvent: false });
    }
  
    return journalEntry;
  }
  

  // onFileSelected(event: Event): void {
  //   const input = event.target as HTMLInputElement;
  //   if (input.files) {
  //     const newFiles = Array.from(input.files);

  //     newFiles.forEach((newFile) => {
  //       const allowedExtensions = ['pdf', 'doc', 'jpg', 'jpeg', 'png'];
  //       const fileExtension = newFile.name.split('.').pop()?.toLowerCase();

  //       if (!fileExtension || !allowedExtensions.includes(fileExtension)) {
  //         this.toastr.warning('Only PDF, DOC, and image files are allowed.');
  //         return;
  //       }
  //       // Prevent duplicates based on name and size
  //       if (
  //         !this.fileDetailsArray.some(
  //           (file) => file.fileName === newFile.name
  //           // && file.isNew
  //         )
  //       ) {
  //         this.fileDetailsArray.push({
  //           fileName: newFile.name,
  //           fileUrl: '',
  //           // isNew: true,
  //         });
  //       }
  //     });

  //     // Upload the new files
  //     this.uploadDocuments(newFiles);
  //   }
  // }

  // uploadDocuments(files: File[]): void {
  //   files.forEach((file: File) => {
  //     this.documentUploadService.uploadDocument(file, 'journals').subscribe({
  //       next: (response) => {
  //         const uploadedFile = this.fileDetailsArray.find(
  //           (f) => f.fileName === file.name
  //           // && f.isNew
  //         );
  //         if (uploadedFile) {
  //           uploadedFile.fileUrl = response.url;
  //         }
  //       },
  //       error: (error) => {
  //         this.toastr.error(error, 'File upload failed');
  //       },
  //     });
  //   });
  //   this.fileInput.nativeElement.value = '';
  // }

  // removeFile(index: number): void {
  //   const file = this.fileDetailsArray[index];
  //   if (file.id) {
  //     // Existing file with ID - call API to remove
  //     // this.onRemoveJournalAttachment(file.id);
  //   } else {
  //     // New file - simply remove from array
  //     this.fileDetailsArray.splice(index, 1);
  //   }
  // }

  onSubmit(): void {
    if (this.newJournalForm.invalid) {
      this.newJournalForm.markAllAsTouched();
      this.toastr.warning('Please fill all required fields.');
      return;
    }

    const journalInputData = {
      date: this.newJournalForm.value.date,
      journalNo: this.newJournalForm.value.journalNo,
      reference: this.newJournalForm.value.reference,
      notes: this.newJournalForm.value.notes,
      totalAmount:this.totalCredit,
      status: this.status,
      isManual: true
    };

    // Separate new and existing entries based on ID
    const createJournalEntries =
      this.newJournalForm.getRawValue().journalEntries.filter(
        (entry: any) => !entry.id
      );
      console.log(createJournalEntries,"createJournalEntries");
      
    const updateJournalEntries =
      this.newJournalForm.getRawValue().journalEntries;
      console.log("form",this.newJournalForm.value);
      console.log("updated",updateJournalEntries);
      
    // const createJournalAttachments = this.fileDetailsArray.filter(
    //   (file) => !file.id
    // );

    // const updateJournalAttachments = this.fileDetailsArray.filter(
    //   (file) => file.id
    // );

    const journalUpdateInput = {
      id: this.journalId,
      ...journalInputData,
    };

    // Conditional API call based on journalId
    if (this.journalId) {
      this.journalService.updateJournal(journalUpdateInput,updateJournalEntries).subscribe({
          next: () => {
            this.loading = false;
            this.toastr.success('Journal Updated Successfully');
            this.router.navigate(['/manual-journals']);
          },
          error: (error) => {
            this.loading = false;
            this.toastr.error(error.message || 'Failed to update journal.');
          },
        });
    } else {
      const cleanedEntries = createJournalEntries.map(
        ({ id, ...rest }: { id?: unknown }) => rest
      );
            this.journalService.createJournal(journalInputData,cleanedEntries).subscribe({
          next: () => {
            this.loading = false;
            this.toastr.success('Journal created successfully!');
            this.router.navigate(['/manual-journals']);
          },
          error: (error) => {
            this.loading = false;
            this.toastr.error(error.message || 'Failed to create journal.');
          },
        });
    }
  }

  // Method for Save (Draft)
  saveAsDraft(): void {
    if (this.difference === 0) {
      this.status = 'Draft';
      this.onSubmit();
    } else {
      this.toastr.warning(
        'The total debit and credit must be equal to save as draft.'
      );
    }
  }

  onVendorSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value;
    this.searchSubject.next(searchTerm);
  }

  // Method for Save (Published)
  // save(): void {
  //   if (this.difference === 0) {
  //     this.status = 'Draft';
  //     this.onSubmit();
  //   } else {
  //     this.toastr.warning(
  //       'The total debit and credit must be equal to publish the journal.'
  //     );
  //   }
  // }

  onRemoveJournalEntry(journalEntryId: number, index: number): void {
    if (journalEntryId) {
      const dialogRef = this.dialog.open(ConfirmDialog);

      dialogRef.afterClosed().subscribe((response) => {
        if (response === true) {
          this.removeJournalEntry(journalEntryId, index);
        }
      });
    } else {
      // Newly added entry — just remove from form array
      this.journalEntries.removeAt(index);
    }
  }

  private removeJournalEntry(journalEntryId: number, index: number): void {
    this.journalService.removeJournalEntry(journalEntryId).subscribe({
      next: () => {
        console.log('Journal Entry removed successfully');
        // Remove the entry from the form array
        this.journalEntries.removeAt(index);
      },
      error: () => {
        console.log('Failed to remove journal entry');
      },
    });
  }

  // onRemoveJournalAttachment(journalAttachmentId: number): void {
  //   const dialogRef = this.dialog.open(ConfirmDialog);
  //   dialogRef.afterClosed().subscribe((response) => {
  //     if (response === true) {
  //       this.journalService
  //         .removeJournalAttachmentById(journalAttachmentId)
  //         .subscribe({
  //           next: () => {
  //             this.fileDetailsArray = this.fileDetailsArray.filter(
  //               (file) => file.id !== journalAttachmentId
  //             );
  //           },
  //           error: () => {
  //             this.toastr.error('Failed to remove journal attachment.');
  //           },
  //         });
  //     }
  //   });
  // }

  onCancel(): void {
    this.newJournalForm.reset();
  }

  private fetchAccounts(search:string = '') {
    this.accountService
      .fetchChartAccounts(search)
      .subscribe({
        next: (accounts) => {
          this.accountData = accounts;
          console.log(this.accountData);
          
        },
        error: (error) => console.error(error),
      });
  }


}
